import Kibo from './kibo'

export { Kibo }
export default { Kibo }
